import Config from "@/utils/config.service";

export interface Configuration
{
    apiBaseUrl: string
}

export default class PromocodesModelConfig {
    public static async getConfiguration(): Promise<Configuration> {
        const configInstance = Config.getInstance();
        const configuration = await configInstance.getConfiguration();

        return configuration.promocodesModule as Configuration;
    }
}